import cssVars from 'css-vars-ponyfill'

export default class Polyfills {
  constructor () {
    // Matches polyfill
    if (!Element.prototype.matches) {
      Element.prototype.matches = Element.prototype.msMatchesSelector
    }

    cssVars()
  }
}
